import {
  ChangeDetectionStrategy,
  Component,
  Output,
  EventEmitter,
} from '@angular/core';
import { MediaService } from '@studiobuki/web-core/lib/media';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoComponent {
  @Output() infoClick = new EventEmitter<void>();

  constructor(public mediaService: MediaService) {}

  public onInfoClick() {
    this.infoClick.emit();
  }
}
